module.exports = new __parcel__URL__("identifiers_logo.9d30579d.png").toString();